module.exports = __webpack_public_path__ + "img/out_car.3bc59efc.png";